import MarketSettingsUsersController from 'lumen/controllers/market/settings/users';

export default class DestinationSettingsUsersController extends MarketSettingsUsersController {}
